import fileicnImg from "../../assets/images/fileicn.svg";
import star from "../../assets/images/star.svg";
import archiveicn from "../../assets/images/archiveicn.svg";
import plusbtnicn from "../../assets/images/plusbtnicn.svg";
import { useDispatch/* , useSelector */ } from "react-redux";
import { getDocuments, resetListingData } from "../../features/user-document/documentListingSlice";
import LabelView from "./LabelView";
import Select from "react-select";
import { NoModuleRights, RoleRightsForModule } from "../../utils/utils";
// import { Link } from "react-router-dom";

const DocumentSideMenu = ({
  setSubCategories,
  subCategories,
  setPerPage,
  setCurrentPage,
  perPage,
  currentPage,
  setCurrentModal,
  setLabelId,
  labelDeteleToggel,
  setSelectedLabel,
  setSelectedCheckbox,
  currentModal,
  toggleModal,
  labelID,
  selectedLabel,
  selectedCheckbox,
  selectedRowsID,
}) => {

  let projectData = JSON.parse(localStorage.getItem("_user"));

  // const { listingData = null } = useSelector((state) => ({
  //   listingData: state?.labelListingSlice?.responseData?.label,
  // }));

  const dispatch = useDispatch();
  /* let projectData = JSON.parse(localStorage.getItem("_user"));
  useEffect(() => {
    dispatch(labelListing(projectData?.projects[0]?.uuid));
  }, []); */
  const languageOptions = [
    {
      label: "English",
      value: "English",
    },
  ];
  return (
    <>
      <div className="leftlang-box">
        <div className="lang-slect-option">
          <Select
            id="inputGroupSelect01"
            name="language"
            placeholder="Please select a parent.."
            value={{ label: "Language: English", value: "English" }}
            isDisabled
            options={languageOptions}
            classNamePrefix="cmn-control"
          />
        </div>
        <div className="lang-list-main">
          <div
            className={`lang-heading ${subCategories === "Documents" ? "active" : ""
              }`}
            onClick={() => {
              if (subCategories !== "Documents") {
                setSubCategories("Documents");
                dispatch(resetListingData());
                setPerPage(10);
                setCurrentPage(1);
                dispatch(
                  getDocuments({
                    perPage: 10,
                    page: 1,
                    project_uuid: projectData?.projects[0]?.uuid,
                  })
                );
              }
            }}
          >
            <img className="lang-cmn-icn" src={fileicnImg} alt="fileicn" />
            <p>Documents</p>
          </div>
          <div
            className={`lang-heading ${subCategories === "Starred" ? "active" : ""
              }`}
            onClick={() => {
              if (subCategories !== "Starred") {
                setSubCategories("Starred");
                dispatch(resetListingData());
                setPerPage(10);
                setCurrentPage(1);
                dispatch(
                  getDocuments({
                    perPage: 10,
                    page: 1,
                    project_uuid: projectData?.projects[0]?.uuid,
                    type: "favourite"
                  })
                );
              }
            }}
          >
            <img className="lang-cmn-icn" src={star} alt="fileicn" />
            <p>Starred</p>
          </div>
          <div
            className={`lang-heading ${subCategories === "Archive" ? "active" : ""
              }`}
            onClick={() => {
              if (subCategories !== "Archive") {
                setSubCategories("Archive");
                dispatch(resetListingData());
                setPerPage(10);
                setCurrentPage(1);
                dispatch(
                  getDocuments({
                    perPage: 10,
                    page: 1,
                    project_uuid: projectData?.projects[0]?.uuid,
                    type: "archive"
                  })
                );
              }
            }}
          >
            <img className="lang-cmn-icn" src={archiveicn} alt="fileicn" />
            <p>Archived</p>
          </div>
        </div>

        {!NoModuleRights('Labels') &&<div className="lang-list-label admin-site-label">
          {RoleRightsForModule("Add", "Labels") &&
            <div className="list-label-title">
              Labels
              <button
                type="button"
                className="btn"
                onClick={() => {
                  // setSelectedLabel('')
                  setSelectedCheckbox('');
                  setCurrentModal("labelModal");
                }}
              >
                <img src={plusbtnicn} alt="plusbtnicn" />
              </button>
            </div>}
          <ul className="emply-list-ul">
            <li>
              <LabelView
                subCategories={subCategories}
                setSubCategories={setSubCategories}
                setCurrentModal={setCurrentModal}
                setLabelId={setLabelId}
                labelDeteleToggel={labelDeteleToggel}
                setSelectedCheckbox={setSelectedCheckbox}
                toggle={toggleModal}
                selectedLabel={selectedLabel}
                selectedCheckbox={selectedCheckbox}
                currentModal={currentModal}
                perPage={perPage}
                currentPage={currentPage}
                selectedRowsID={selectedRowsID}
              />
            </li>
          </ul>
        </div>}
      </div>
    </>
  );
};

export default DocumentSideMenu;
